import "./fleetCardStatus.css";

//todo ujj
// How long has the vehicle been in its current state?
// function formatDwell(timestamp, status) {
//   if (!timestamp) return null;
//   const mins = Math.floor((Date.now() - new Date(timestamp)) / 60000);
//   if (mins < 1) return status === "online" ? "Just started" : "Just stopped";
//   if (mins < 60) return `${mins}m`;
//   return `${Math.floor(mins / 60)}h ${mins % 60}m`;
// }

const FleetCardStatus = ({
  telemetry = {
    speed: 0,
    binActive: false,
    ptoActive: false,
    tailGateActive: false,
    tarpActive: false,
  },
}) => {
  //const dwell = formatDwell(fleet.timestamp, status);
  //{dwell && <span className="hud-dwell">{dwell}</span>}


  // Active flags as an array
  // const activeFlags = Object.entries(fleet.flags || {})
  //   .filter(([, v]) => v)
  //   .map(([k]) => k.replace(/Active$/, "").toUpperCase());
  // {activeFlags.length > 0 &&
  //                 activeFlags.map((f) => (
  //                   <span key={f} className="hud-flag">
  //                     {f}
  //                   </span>
  //                 ))}

  const isSpeeding = telemetry.speed > 10;

  const flags = [
    { id: "bin", label: "BIN", active: telemetry.binActive },
    { id: "pto", label: "PTO", active: telemetry.ptoActive },
    { id: "tg", label: "T/G", active: telemetry.tailGateActive },
    { id: "tarp", label: "TARP", active: telemetry.tarpActive },
  ];

  const getStatusClass = (active) => {
    if (!active) return "status-off";
    return isSpeeding ? "status-critical" : "status-warning";
  };

  return (
    <div className="fleet-status-grid">
      {flags.map((flag) => (
        <div
          key={flag.id}
          className={`fcs-status-badge ${getStatusClass(flag.active)}`}
        >
          <div className="indicator-dot" />
          <span className="badge-label">{flag.label}</span>
        </div>
      ))}
    </div>
  );
};

export default FleetCardStatus;
